module.exports = __webpack_public_path__ + "img/ewm_failure.55683429.png";